import React, { useState } from 'react';
import '../styles/FerCalculator.css';

function FerCalculator() {
    const [grades, setGrades] = useState({
      year1: "",
      year2: "",
      year3: "",
      year4: "",
      croatian: "",
      math: "",
      foreignLang: "",
      mathPercent: "",
      physicsPercent: "",
    });

    const [totalPoints, setTotalPoints] = useState(null);
    const [partialResults, setPartialResults] = useState({
      highSchoolY1: null,
      highSchoolY2: null,
      highSchoolY3: null,
      highSchoolY4: null,
      highSchoolTotal: null,
      maturaGradePoints: null,
      mathPoints: null,
      physicsPoints: null,
      maturaExamPoints: null,
    });
  
    const handleChange = (e) => {
      setGrades({ ...grades, [e.target.name]: e.target.value });
    };
    // const handleChange = (e) => {
    //   const { name, value } = e.target;
    //   const newGrades = { ...grades, [name]: value };
    //   setGrades(newGrades);
  
      // Calculate the partial result when an input changes
      // calculatePartialResults(newGrades);
    //   calculatePoints(newGrades);
    // };

    // const calculatePoints = (newGrades) => {
    //   const { year1, year2, year3, year4, croatian, math, foreignLang, mathPercent, physicsPercent } = newGrades;  
  
    const calculatePoints = () => {
      const { year1, year2, year3, year4, croatian, math, foreignLang, mathPercent, physicsPercent } = grades;
  
      // Convert inputs to numbers
      const y1 = parseFloat(year1) || 0;
      const y2 = parseFloat(year2) || 0;
      const y3 = parseFloat(year3) || 0;
      const y4 = parseFloat(year4) || 0;
      const cro = parseInt(croatian) || 0;
      const mat = parseInt(math) || 0;
      const lang = parseInt(foreignLang) || 0;
      const mathP = parseFloat(mathPercent) || 0;
      const physicsP = parseFloat(physicsPercent) || 0;
  
      // High school points
      const highSchoolY1 = (y1 / 5.0) * 80;
      const highSchoolY2 = (y2 / 5.0) * 80;
      const highSchoolY3 = (y3 / 5.0) * 80;
      const highSchoolY4 = (y4 / 5.0) * 80;
      const highSchoolTotal = highSchoolY1 + highSchoolY2 + highSchoolY3 + highSchoolY4;

      // Matura grade points
      const maturaGradePoints = ((cro + mat + lang) / 15.0) * 80;

      // Matura exam percent points
      const mathPoints = (mathP / 100.0) * 360;
      const physicsPoints = (physicsP / 100.0) * 240;
      const maturaExamPoints = mathPoints + physicsPoints;
    
      // Total points
      const total = highSchoolTotal + maturaGradePoints + maturaExamPoints;

      // Update the partial results for each input field
      setPartialResults({
        highSchoolY1: highSchoolY1.toFixed(2),
        highSchoolY2: highSchoolY2.toFixed(2),
        highSchoolY3: highSchoolY3.toFixed(2),
        highSchoolY4: highSchoolY4.toFixed(2),
        highSchoolTotal: highSchoolTotal.toFixed(2),
        maturaGradePoints: maturaGradePoints.toFixed(2),
        mathPoints: mathPoints.toFixed(2),
        physicsPoints: physicsPoints.toFixed(2),
        maturaExamPoints: maturaExamPoints.toFixed(2),
      });
      setTotalPoints(total.toFixed(1));
    };
  
    return (
      <div className="calculator">
        <h1>Upis na FER - Kalkulator bodova</h1>
  
        <div className="input-group">
          <h2>Prosjek svih ocjena srednje škole (4x80 bodova)</h2>
          <ul>
            <li>
              <label>Prosjek 1. razreda</label>
              <input type="number" min="0.00" max="5.00" name="year1" step="0.01" placeholder="5.00" onChange={handleChange} />
              {partialResults.highSchoolY1 && <span className="partial-result">{partialResults.highSchoolY1}</span>}
            </li>
            <li>
              <label>Prosjek 2. razreda</label>
              <input type="number" min="0.00" max="5.00" name="year2" step="0.01" placeholder="5.00" onChange={handleChange} />
              {partialResults.highSchoolY2 && <span className="partial-result">{partialResults.highSchoolY2}</span>}
            </li>
            <li>
              <label>Prosjek 3. razreda</label>
              <input type="number" min="0.00" max="5.00" name="year3" step="0.01" placeholder="5.00" onChange={handleChange} />
              {partialResults.highSchoolY3 && <span className="partial-result">{partialResults.highSchoolY3}</span>}
            </li>
            <li>
              <label>Prosjek 4. razreda</label>
              <input type="number" min="0.00" max="5.00" name="year4" step="0.01" placeholder="5.00" onChange={handleChange} />
              {partialResults.highSchoolY4 && <span className="partial-result">{partialResults.highSchoolY4}</span>}
            </li>
          </ul>
          {partialResults.highSchoolTotal && <span className="partial-result">{partialResults.highSchoolTotal} / 320</span>}
        </div>
  
        <div className="input-group">
          <h2>Ocjene na državnoj maturi</h2>
          <ul>
            <li>
              <label>Hrvatski jezik</label>
              <input type="number" min="1" max="5" name="croatian" step="1" placeholder="5" onChange={handleChange} />
            </li>
            <li>
              <label>Matemateka A</label>
              <input type="number" min="1" max="5" name="math" step="1" placeholder="5" onChange={handleChange} />
            </li>
            <li>
              <label>Strani jezik</label>
              <input type="number" min="1" max="5" name="foreignLang" step="1" placeholder="5" onChange={handleChange} />
            </li>
          </ul>
          {partialResults.maturaGradePoints && <span className="partial-result">{partialResults.maturaGradePoints} / 80</span>}
        </div>
  
        <div className="input-group">
          <h2>Postotak riješenosti ispita na državnoj maturi</h2>
          <ul>
            <li>
              <label>Matematika A</label>
              <input type='number'  min="0" max="100" name="mathPercent" step="0.01" placeholder="100 (%)" onChange={handleChange} />
              {partialResults.mathPoints && <span className="partial-result">{partialResults.mathPoints}</span>}
            </li>
            <li>
              <label>Fizika</label>
              <input type="number"  min="0" max="100" name="physicsPercent" step="0.01" placeholder="100 (%)" onChange={handleChange} />
              {partialResults.physicsPoints && <span className="partial-result">{partialResults.physicsPoints}</span>}
            </li>
          </ul>
          {partialResults.maturaExamPoints && <span className="partial-result">{partialResults.maturaExamPoints} / 600</span>}
        </div>
  
        <button className="calculate-btn" onClick={calculatePoints}>Izračunaj</button>
  
        {totalPoints !== null && (
          <div className="final-result">
            <p>Ukupno ostvareno <span className="result">{totalPoints} </span>/ 1000 bodova</p>
          </div>
        )}

        <div className='info'>
          <h2>Dodatne informacije</h2>
          <p>Upis na Fakultet elektrotehnike i računarstva ostvaruje najbolje rangiranih 640 kandidata.</p>
          <p>Ukupan broj bodova koje učenik može osvojiti je 1000.</p>
          <p>Svi bodovi se računaru po formuli: Broj bodova = Ostvareni rezultat / Maksimalni mogući
          rezultat x Maksimalni mogući broj bodova.</p>
          <p>Prosjek ocjena iz srednje škole donosi maksimalno 320 bodova, pri čemu svaka godina
          donosi maksimalno 80 bodova (npr. 4,50 / 5,0 * 80 = 72,0b).</p>
          <p>Rezultatima državne mature može se osvojiti maksimalno 680 bodova. Zbroj ocjena Hrvatskog
            jezika, Matematike A i stranog jezika donosi maksimalno 80 bodova (npr. (4+3+5) / 15 * 80 = 64,0b).
            Ostvareni prosjek iz matematike donosi maksimalno 360 bodova (npr. za 85% 85 / 100 * 360 = 306,0b).
            Ostvareni prosjek iz fizike donosi maksimalno 240 bodova (npr. za 72% 72/100 * 240 = 172.8b).</p>
          <p>Za uspješan upis potrebno je položiti Hrvatski jezik, strani jezik, Matematiku A i Fiziku.
            Matematika A i Fizika pritom nose najviše bodova (36% + 24% + 2.67%(ocjena iz mat)), dok Hrvatski i
            strani jezik nose relativno malo (zajedno 5.33%).</p>
          <p>Minimalan potreban broj bodova za upis se mijenja iz godine u godinu. Posljednji upisani kandidat u 
            godini 2019. imao je 722.4 bodova, 2021. je to bilo 759.3 bodova, a 2023. 775.3 bodova.</p>

          <table className='history-table'>
              <caption>Bodovni prag po godinama</caption>
            <thead>
              <tr>
                <th>2012</th>
                <th>2013</th>
                <th>2019</th>
                <th>2021</th>
                <th>2023</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>577.4</td>
                <td>611.5</td>
                <td>722.4</td>
                <td>759.3</td>
                <td>775.3</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p id='disclaimer'><strong>Napomena:</strong> Ova web stranica <u>nije</u> razvijena u suradnji sa Fakultetom elektrotehnike i 
          računarstva i stoga su svi podatci na njoj neslužbenog karaktera i ne moraju nužno predstavljati aktualno stanje. Za službene
          informacije potrebno je posjetiti službene stranice fakulteta <a href='https://www.fer.unizg.hr/'>www.fer.hr</a>.</p>
      </div>
    );
  }
  
  export default FerCalculator;